<app-left-side-nav></app-left-side-nav>
<app-header></app-header>

<!-- page content area start -->
<ng-container *ngIf="!isLoading; else loadingTemplate">
<div class="afterLoginPageContainer" translate="no">
    <div class="container p-0">
        <div class="mainContent" *ngIf="catalogDetails">
            <div class="catalog-header" [ngClass]="{'mobile-padd':!isAuthenticated}">
                <div class="top-bar">
                    <button class="back-btn" (click)="onClickBack()">
                        <i class="fa fa-chevron-left"></i>
                    </button>
                    <div class="title-section">
                        <h2>Catalogue</h2>
                        <p><span class="me-1"> {{companiesCount}} {{ companiesCount <=1 ? 'Company' : 'Companies' }} </span> | <span class="ms-1">
                          {{ productsCount }}  {{ productsCount <= 1 ? 'Product' : 'Products' }} </span></p>
                    </div>
                    <div class="icons">
                        <i class="fa-regular fa-circle-check" (click)="openWishlist()" *ngIf="isAuthenticated"></i>
                        <i class="fa fa-search" id="searchIcon" (click)="openFloatingSearch()"></i>
                    </div>
                </div>

                 <!-- Floating Search Bar -->
                <div class="floating-search" id="floatingSearch" [class.active]="isSearchOpen">
                    <div class="search-container">
                        <i class="fa fa-search"></i>
                        <input type="text" 
                        placeholder="Search..." 
                        id="searchInput" 
                        [(ngModel)]="searchText"
                        #searchInput 
                        (ngModelChange)="onSearchInput()"
                        />
                        <i class="fa fa-times" id="closeSearch" (click)="closeFloatingSearch()"></i>
                    </div>
                </div>

                <div class="tab-section">
                    <button class="tab" [class.active]="activeTab ==='pavilions'" (click)="setActiveTab('pavilions')">Pavilions</button>
                    <button class="tab" [class.active]="activeTab ==='areaofinterest'" (click)="setActiveTab('areaofinterest')">Area of Interest</button>
                </div>
            </div>
            <div class="tab-content" id="pavilions" [class.active]="activeTab ==='pavilions'" [ngClass]="{'mobile-mt':!isAuthenticated}">
                <div class="pavilion-section" *ngIf="pavilionGroups.length">
                    <div class="d-flex align-items-center justify-content-between mb-4">
                    <h6 class="pavilion-title mb-0">Choose a Pavilion</h6>
                    <button (click)="viewLayout()" class="view-layout-btn">View Layout</button>
                    </div>
                    <div class="mSection d-flex" *ngIf="allPavilions?.length">
                        <div class="grp pragati">
                            <div class="pGrp">
                                <div class="sng" *ngFor="let pavilion of allPavilions">
                                    <a (click)="viewProductList(pavilion)">
                                        <div class="img-Wrapper">
                                            <img [src]="pavilion.image_url" alt="{{ pavilion.name }}" />
                                        </div>
                                        <h6 class="text-center mt-2 text-white">{{ pavilion.name }}</h6>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-content" id="areaofinterest" [class.active]="activeTab ==='areaofinterest'" [ngClass]="{'mobile-mt':!isAuthenticated}" >
                <div class="selectAreaOfInterest" *ngIf="isAuthenticated">
                    <div class="selected" *ngIf="selectedCategories.length > 0">
                        <h3 class="title">Area of interest selected by you</h3>
                        <div class="selectcategory">
                            <div class="category-block" *ngFor="let category of selectedCategories" (click)="viewProductsOfCategory(category)">
                                <div class="custom-control custom-checkbox">
                                    <input [id]="'category_'+category.id" [name]="category.app_name_english" [value]="category.id"
                                        class="custom-control-input" type="checkbox" [disabled]="true" >
                                    <label [for]="'category_'+category.id" class="custom-control-label">
                                        <div class="imgOut">
                                            <img src="{{category.image_url}}" [alt]="category.app_name_english" class="img-fluid">
                                        </div>
                                        <p class="mb-0">{{ category.app_name_english }}</p>
                                    </label>
                                </div>
                            </div>
                         
                        </div>
                    </div>
                    <div class="other" *ngIf="otherCategories.length > 0">
                        <h3 class="title">{{ otherCatTitle }}</h3>
                        <div class="selectcategory">
                            <div class="category-block" *ngFor="let category of otherCategories">
                                <div class="custom-control custom-checkbox">
                                    <input [id]="'category_'+ category.id" [name]="category.app_name_english" [value]="category.id"
                                        class="custom-control-input" type="checkbox" [disabled]="true" >
                                    <label [for]="'category_'+ category.id" class="custom-control-label">
                                        <div class="imgOut">
                                            <img src="{{category.image_url}}" [alt]="category.app_name_english" class="img-fluid">
                                        </div>
                                        <p class="mb-0">{{ category.app_name_english }}</p>
                                    </label>
                                </div>
                            </div>
                            
                        </div>
                    </div>

                    <div class="text-center my-3" *ngIf="selectedCategories.length === 0">

                        <img src="assets/images/agriculture.png" alt="info" class="me-2">
                        <h2 class="mt-3">You have not selected any Area of Interest. Please select to proceed.</h2>

                    </div>

                    <div class="text-center my-3 footBtn" (click)="editAreaOfInterest()">
                        <button type="submit" class="btn subBtn">{{ catButton }}</button>
                    </div>
                </div>

                <div class="selectAreaOfInterest" *ngIf="!isAuthenticated">
                    <div class="other">
                        <h3 class="title">Area of interest</h3>
                        <div class="selectcategory">
                            <div class="category-block" *ngFor="let category of allCategoriesList">
                                <div class="custom-control custom-checkbox">
                                    <input [id]="'category_'+category.id" [name]="category.app_name_english" [value]="category.id"
                                        class="custom-control-input" type="checkbox" [disabled]="true" >
                                    <label [for]="'category_'+category.id" class="custom-control-label">
                                        <div class="imgOut">
                                            <img src="{{category.image_url}}" [alt]="category.app_name_english" class="img-fluid">
                                        </div>
                                        <p class="mb-0">{{ category.app_name_english }}</p>
                                    </label>
                                </div>
                            </div>
                         
                        </div>
                    </div>
                    
                    <div class="text-center my-3 footBtn" (click)="login()">
                        <button type="submit" class="btn subBtn">Login</button>
                    </div>
                </div>

            </div>
            <div class="catlogWrapper" (click)="goToTicketPage()" *ngIf="this.eventDetails?.allow_to_register === 1">
                <img src="/assets/images/buy_your_ticket.png" alt="Buy Ticket" />
            </div>
            <div class="catlogWrapper mt-0" *ngIf="isContestActive">
                <img 
                [src]="isVotingActive 
                ? '/assets/images/me/voting-tile.png' 
                : '/assets/images/ExploreIdeas.png'"
                alt="Vote Now" 
                (click)="onClickVote()" />
            </div>
        </div>
    </div>

    

</div>
</ng-container>

<ng-template #loadingTemplate>
    <div class="loader-container">
      <app-loader></app-loader>
  
    </div>
  </ng-template>